import { Link } from "react-router-dom";

export default function TopNotificationBar({ visible, onClose }) {
  if (!visible) return null;

  const handleClose = () => {
    try {
      sessionStorage.setItem("emicron_topbar_dismissed", "1");
    } catch (_) {}
    onClose?.();
  };

  if (!visible) return null;

  return (
    <div className="top-notification-bar">
      <div className="container d-flex align-items-center justify-content-between gap-2">
        <span className="top-notification-text">
          <i className="bi bi-megaphone me-2"></i>
          <span className="top-notification-text__full">
            Welcome to Emicron Techsolutions Pvt Ltd — Your trusted IT solutions partner.{" "}
            <Link to="/services">Explore solutions</Link>.
          </span>
          <span className="top-notification-text__short">
            Welcome to Emicron — <Link to="/services">Explore solutions</Link>
          </span>
        </span>
        <button type="button" className="top-notification-close" onClick={handleClose} aria-label="Close">
          <i className="bi bi-x-lg"></i>
        </button>
      </div>
    </div>
  );
}
